var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.56768 27.5081L8.00685 27.9896L8.35822 27.4408C10.3906 24.2659 13.9489 22.16 18.0002 22.16C22.051 22.16 25.6089 24.2654 27.6416 27.4396L27.993 27.9884L28.4321 27.5069C30.7189 24.999 32.1141 21.6616 32.1141 17.9998C32.1141 10.2044 25.7945 3.88497 17.9993 3.88497C10.2039 3.88497 3.88448 10.2044 3.88448 17.9998C3.88448 21.6622 5.28009 24.9999 7.56768 27.5081ZM26.6631 29.1435L27.0079 28.8751L26.7881 28.4975C25.0273 25.4718 21.7505 23.44 18.0002 23.44C14.2495 23.44 10.9724 25.4723 9.21176 28.4985L8.99206 28.8761L9.33681 29.1445C11.7281 31.0058 14.7349 32.1146 17.9993 32.1146C21.2643 32.1146 24.2716 31.0053 26.6631 29.1435ZM2.60449 17.9998C2.60449 9.49747 9.49698 2.60498 17.9993 2.60498C26.5015 2.60498 33.3941 9.49747 33.3941 17.9998C33.3941 26.5019 26.5015 33.3946 17.9993 33.3946C9.49699 33.3946 2.60449 26.5019 2.60449 17.9998ZM12.8596 15.6118C12.8596 12.773 15.1609 10.4718 17.9996 10.4718C20.8384 10.4718 23.1396 12.773 23.1396 15.6118C23.1396 18.4505 20.8384 20.7518 17.9996 20.7518C15.1609 20.7518 12.8596 18.4505 12.8596 15.6118ZM17.9996 11.7518C15.8678 11.7518 14.1396 13.4799 14.1396 15.6118C14.1396 17.7436 15.8678 19.4718 17.9996 19.4718C20.1315 19.4718 21.8596 17.7436 21.8596 15.6118C21.8596 13.4799 20.1315 11.7518 17.9996 11.7518Z",
    fill: "#04D538",
    stroke: "#04D538"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.3886a39ad2fe5aebb1eb5f2ac3d8c4a9.svg";
export { ForwardRef as ReactComponent };